import React from 'react';
import { IconProps } from '../types/types';

const QCOM: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#3253DC" d="M0 0h18v18H0z"/><path d="M10.508 13.769a5 5 0 111.645-.888l.628 1.57a.4.4 0 01-.372.549h-1.138a.4.4 0 01-.372-.251l-.391-.98zm.84-2.9a3 3 0 10-1.586 1.034l-.543-1.354A.4.4 0 019.591 10h1.138a.4.4 0 01.372.251l.246.617z" fill="#fff"/></svg>
);

export default QCOM;